import React from "react";
import "./custom.css";

const timelineData = [
  {
    id: 1,
    color: "purple",
    title: "Laptop - LAP09284",
    date: "10 Jan 2024",
    status: "Assert Handover",
  },
  {
    id: 2,
    color: "blue",
    title: "ID Card - ID09284",
    date: "10 Jan 2024",
    status: "Assert Return",
  },
  {
    id: 3,
    color: "red",
    title: "Laptop - LAP09284",
    date: "10 Jan 2024",
    status: "Lost Reported",
  },
  {
    id: 4,
    color: "purple",
    title: "Mobile Phone - Mob 0209SAM",
    date: "10 Jan 2024",
    status: "Assert Handover",
  },
  {
    id: 5,
    color: "blue",
    title: "Mobile Phone - Mob 0209SAM",
    date: "10 Mar 2024",
    status: "Assert Return",
  },
];

const Timeline = () => {
  return (
    // Timeline.jsx
    <div className="timeline-container mt-3">
      {timelineData.map((item, index) => (
        <div className="timeline-item" key={index}>
          
          <div className="timeline-left">
            <div className="dot-wrapper">
              <div className="outer-circle">
                <div className={`dot_ ${item.color}`}></div>
              </div>
            </div>
          </div>

          <div className="timeline-content">
            <div className="title">{item.title}</div>
            <div className="date">{item.date}</div>
          </div>

          <div className="timeline-status">{item.status}</div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;
